<template>
    <ies-form-field :field="field">
        {{ this.field.value }}
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-disabled',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
        }
    },
}
</script>


